module.exports = __webpack_public_path__ + "img/code.c52f71f7.png";